import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

import {Message} from "primeng/components/common/api";

import {CognitoUser, ICognitoUserAttributeData} from "amazon-cognito-identity-js";
import {AwsService} from "../aws.service";
import {User} from "../../api/model/user";
import {config} from "../config";

import {ImageEditorComponent} from "../image-editor/image-editor.component";

@Component({
    template: require('./user-form.component.pug'),
    styles: [require('./user-form.component.css')]
})
export class UserFormComponent implements OnInit {
    @ViewChild("imageEditor") imageEditor: ImageEditorComponent;
    msgs: Message[] = [];
    config = config;

    name: string;
    oldPasswd: string;
    newPasswd: string;
    rnewPasswd: string;

    picture: string;
    upload: string;
    blob: Blob;

    model: User = {};

    constructor(private route: ActivatedRoute, private _awsService: AwsService) {
    }

    async ngOnInit() {
        let id = this.route.snapshot.paramMap.get("id");
        if (id !== "new") {
            this.model = (await this._awsService.api.usersIdGet({id: this.config.identityId})).data;
            console.log(this.model);
            this.name = this.model.name;
            this.picture = this.model.picture;
        }
    }

    async uploadHandler(event: any, uploader: any) {
        console.log('uploadHandler', event.files[0]);
        let FR = new FileReader();
        FR.addEventListener('load', (e:any) => this.upload = this.picture = e.target.result);
        FR.readAsDataURL(event.files[0]);
        this.blob = event.files[0];
        uploader.clear();
    }

    async save() {
        this.msgs = [];
        if (this.oldPasswd && this.newPasswd !== this.rnewPasswd) {
            this.msgs.push({
                severity: 'error',
                summary: 'Contraseñas no coinciden'
            });
            return;
        }
        if (this.oldPasswd && this.newPasswd === this.rnewPasswd) {
            const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!#$^%&*()+=\-\[\]\\\.';,\/{}|\":<>? ])[A-Za-z\d@!#$^%&*()+=\-\[\]\\\.';,\/{}|\":<>? ]{8,}/g;
            if (!(re.test(this.newPasswd))) {
                this.msgs.push({
                    severity: 'error',
                    summary: 'Contraseña incorrecta, debe tener al menos 8 caracteres, una letra mayuscula, una letra nimuscula, un numero y un caracter espacial'
                });
                return;
            }
            await this.changePassword(this._awsService.cognitoUser, this.oldPasswd, this.newPasswd);
        }
        let attributeList:ICognitoUserAttributeData[] = [];
        if (this.name !== this.model.name) {
            const attribute:ICognitoUserAttributeData = {Name: 'name', Value: this.name};
            attributeList.push(attribute);
            this.model.name = this.name;
        }
        if (this.blob) {
            const s3 = new this._awsService.AWS.S3(this._awsService.credentials);
            let key = 'cognito/' + this._awsService.identityId + '/picture.jpg';
            let params = {Bucket: 'sintesis-users', Key: key, Body: this.blob, ACL: 'public-read'};
            let data = await s3.upload(params).promise();
            const attribute:ICognitoUserAttributeData = {Name: 'picture', Value: data.Location};
            attributeList.push(attribute);
            this.model.picture = data.Location;
        }
        if (attributeList.length) {
            try {
                this.model = (await this._awsService.api.usersIdPut({id: this.model.id}, this.model)).data;
                await this.updateAttributes(this._awsService.cognitoUser, attributeList);
                this.name = this.model.name;
                this.picture = this.model.picture;
            } catch (err) {
                console.error(err);
                this.msgs.push({
                    severity: 'error',
                    summary: 'Error al actualiazar los atributos',
                    detail: err
                });
            }
        }
    }

    changePassword(cognitoUser: CognitoUser, oldPasswd:string, newPasswd:string) {
        return new Promise((resolve, reject) => {
            cognitoUser.changePassword(oldPasswd, newPasswd, (err, result) => {
                if (err) reject(err);
                else resolve(result);
            })
        });
    }

    updateAttributes(cognitoUser: CognitoUser, attributeList:ICognitoUserAttributeData []) {
        return new Promise((resolve, reject) => {
            cognitoUser.updateAttributes(attributeList, (err, result) => {
                if (err) reject(err);
                else resolve(result);
            });
        });
    }

    cropImage(event: any) {
        let FR = new FileReader();
        FR.addEventListener('load', (e:any) => this.picture = e.target.result);
        FR.readAsDataURL(event.blob);
        this.blob = event.blob;
    }

    readyImage(): void {
        let data = this.imageEditor.cropper.getImageData();
        this.imageEditor.cropper.setCropBoxData(data);
        this.imageEditor.cropper.getCroppedCanvas().toBlob((blob:any) => this.blob = blob, 'image/jpeg', 1);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/users/user-form.component.ts